import { Grid } from "antd";
const { useBreakpoint } = Grid;

const useResponsiveness = () => {
  const { xs, sm, md, lg, xl, xxl } = useBreakpoint();

  return { xs, sm, md, lg, xl, xxl };
};

export { useResponsiveness };
